import http from '../../utils/fetch';

export default {
    baseurl: '/api/swyl/v1/guoke',
    GKListPage(query) {
        return http({
            url: this.baseurl + '/guokeOrder/selectPage',
            method: 'get',
            params: query
        });
    },
    ExportGKList(query) {
        return http({
            url: this.baseurl + '/guokeOrder/downloadExcel',
            method: 'get',
            params: query,
            responseType: 'blob'
        });
    },
    InventoryListPage(query){
        return http({
            url: this.baseurl + '/nationalScience/selectListPage',
            method: 'post',
            params: query
        });
    },
    ExportInventoryList(query) {
        return http({
            url: this.baseurl + '/nationalScience/downloadExcel',
            method: 'post',
            params: query,
            responseType: 'blob'
        });
    },

    getInvoice(query) {
        return http({
            url: this.baseurl + '/guokeOrder/getInvoiceFileByNo',
            method: 'get',
            params: query
        });
    },
    updateGuokeOrder(query) {
        return http({
            url: this.baseurl + '/guokeOrder/updateGuokeOrder',
            method: 'post',
            data: query
        });
    },

    updateSalesRegion(query) {
        return http({
            url: '/api/swyl/v1/demo/bscGuokeOrderSalesRegion/updateSalesRegion',
            method: 'post',
            params: query
        });
    },

    gkOrderList(query) {
        return http({
            url: '/api/swyl/v1/demo/bscGuokeOrderSalesRegion/gkOrderList',
            method: 'post',
            params: query
        });
    },
    gkOrderPass(query) {
        return http({
            url: '/api/swyl/v1/demo/bscGuokeOrderSalesRegion/gkOrderPass',
            method: 'post',
            data: query
        });
    },
    // 国科经销商产品控制表
    gkAgentMaterialSelect(query) {
        return http({
            url: '/api/swyl/v1/demo/bscGuokeAgentMaterial/selectPage',
            method: 'post',
            params: query
        });
    },
    //修改提交
    gkAgentMaterialUpdateById(query) {
        return http({
            url: '/api/swyl/v1/demo/bscGuokeAgentMaterial/updateById',
            method: 'post',
            params: query
        });
    },
    //修改提交
    gkAgentMaterialInsert(query) {
        return http({
            url: '/api/swyl/v1/demo/bscGuokeAgentMaterial/insert',
            method: 'post',
            params: query
        });
    },
    //修改提交
    gkAgentMaterialSelectById(id) {
        return http({
            url: '/api/swyl/v1/demo/bscGuokeAgentMaterial/selectById?id='+id,
            method: 'post',
        });
    },
    //修改提交
    gkAgentMaterialDeleteById(id) {
        return http({
            url: '/api/swyl/v1/demo/bscGuokeAgentMaterial/deleteById?id='+id,
            method: 'post',
        });
    },

    //国科产品列表
    getGkProductList(query) {
        return http({
            url: '/api/swyl/v1/demo/bscGuokeAgentMaterial/getGkProductList',
            method: 'post',
            data: query
        });
    },

    gkTejiaSelect(query){
        return http({
            url: '/api/swyl/v1/demo/specialOfferAvaiNumberLog/selectListPage',
            method: 'post',
            params: query
        });
    },
    // 作废
    gkTejiaWithdraw(id){
        return http({
            url: '/api/swyl/v1/demo/specialOfferAvaiNumberLog/gkTejiaWithdraw?id='+id,
            method: 'post',
        });
    },

}
